import styled from 'styled-components'
import { rem } from 'polished'
import Image from 'components/Common/Image'

export const SectionContent = styled.div`
  margin-top: ${rem(16)};
`

export const Img = styled(Image)`
  max-width: 100%;
`

export const Section = styled.div`
  margin-top: ${rem(32)};
`
